// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as AlertActions } from '../duck';
import Alert from '../components/Alert';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    id: state.alert.id,
    alertType: state.alert.alertType,
    open: state.alert.open,
    message: state.alert.message,
    messageIntl: state.alert.messageIntl,
    locale: state.locale,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(AlertActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Alert);



// WEBPACK FOOTER //
// ./src/modules/alert/container/AlertContainer.jsx